import { Avatar1, Avatar10, Avatar11, Avatar12, Avatar13, Avatar14, Avatar15, Avatar16, Avatar17, Avatar2, Avatar3, Avatar4, Avatar5, Avatar6, Avatar7, Avatar8, Avatar9 } from "../assets";

const artists = [
	{ name: "KeepItReal", sales: 40.1, img: Avatar1, ntfs: 230 },
	{ name: "DigiLabs", sales: 60.25, img: Avatar2, ntfs: 350 },
	{ name: "GravityOne", sales: 80.5, img: Avatar3, ntfs: 500 },
	{ name: "Juanie", sales: 25.75, img: Avatar4, ntfs: 120 },
	{ name: "BlueWhale", sales: 100.0, img:Avatar12, ntfs: 600 },
	{ name: "MrFox", sales: 70.35, img: Avatar5, ntfs: 420 },
	{ name: "Shroomie", sales: 30.15, img: Avatar6, ntfs: 180 },
	{ name: "Robotica", sales: 90.2, img: Avatar7, ntfs: 550 },
	{ name: "RustyRobot", sales: 55.8, img: Avatar8, ntfs: 320 },
	{ name: "AnimaKid", sales: 120.0, img: Avatar9, ntfs: 720 },
	{ name: "Dotgu", sales: 44.9, img: Avatar10, ntfs: 260 },
	{ name: "Ghiblier", sales: 75.6, img: Avatar11, ntfs: 450 },
	{ name: "BeKind2Robots", sales: 66.15, img: Avatar13, ntfs: 390 },
	{ name: "DreamWeavers", sales: 88.35, img: Avatar14, ntfs: 520 },
	{ name: "PulseWave", sales: 110.5, img: Avatar15, ntfs: 660 },
	{ name: "PixelPunch", sales: 22.3, img: Avatar16, ntfs: 130 },
	{ name: "SkyRiders", sales: 77.25, img: Avatar17, ntfs: 460 },
	{ name: "SolarFlares", sales: 95.4, img: Avatar4, ntfs: 570 },
	{ name: "Electronica", sales: 33.7, img: Avatar10, ntfs: 200 },
	{ name: "AquaFins", sales: 50.9, img: Avatar8, ntfs: 300 },
];

export default artists;
